import { render } from "./toTop.vue?vue&type=template&id=63273da8&scoped=true"
import script from "./toTop.vue?vue&type=script&lang=ts"
export * from "./toTop.vue?vue&type=script&lang=ts"

import "./toTop.vue?vue&type=style&index=0&id=63273da8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-63273da8"

export default script